import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { Notfound } from './app/pages/notfound/notfound';
import { AuthGuard } from '@/middleware/auth.guard';

export const appRoutes: Routes = [
    {
        path: '',
        loadComponent: () => import('./app/modules/landing/landing.component').then((m) => m.LandingComponent)
    },
    {
        path: 'dashboard',
        component: AppLayout,
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./app/modules/dashboard/dashboard.component').then((m) => m.DashboardComponent)
            }
        ],
        canActivate: [AuthGuard]
    },
    {
        path: 'detalle-usuario/:id',
        component: AppLayout,
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./app/modules/detalle-user/detalle-user.component').then((m) => m.DetalleUserComponent)
            }
        ],
        canActivate: [AuthGuard]
    },
    {
        path: 'administracion',
        component: AppLayout,
        children: [
            {
                path: 'usuarios',
                loadComponent: () => import('./app/modules/users/users.component').then((m) => m.UsersComponent)
            },
            {
                path: 'invitaciones',
                loadComponent: () =>
                    import('./app/modules/invitaciones/invitaciones.component').then((m) => m.InvitacionesComponent)
            },
            {
                path: 'sedes',
                loadComponent: () => import('./app/modules/sedes/sedes.component').then((m) => m.SedesComponent)
            }
        ],
        canActivate: [AuthGuard]
    },
    {
        path: 'control',
        children: [
            {
                path: '',
                loadComponent: () => import('@/modules/control/control.component').then((m) => m.ControlComponent)
            }
        ],
        canActivate: [AuthGuard]
    },
    {
        path: 'reportes',
        component: AppLayout,
        children: [
            {
                path: '',
                loadComponent: () => import('./app/modules/reportes/reportes').then((m) => m.Reportes)
            }
        ],
        canActivate: [AuthGuard]
    },
    {
        path: 'novedades',
        component: AppLayout,
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./app/modules/novedades/novedades.component').then((m) => m.NovedadesComponent)
            }
        ],
        canActivate: [AuthGuard]
    },
    {
        path: 'mi-perfil',
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./app/modules/mi-perfil/mi-perfil.component').then((m) => m.MiPerfilComponent)
            }
        ],
        canActivate: [AuthGuard]
    },
    {
        path: 'mi-plan',
        component: AppLayout,
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./app/modules/mi-plan/mi-plan.component').then((m) => m.MiPlanComponent)
            }
        ],
        canActivate: [AuthGuard]
    },
    {
        path: 'virtual',
        component: AppLayout,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./app/modules/virtual/virtual.component').then((m) => m.VirtualComponent)
            },
            {
                path: 'entidades',
                loadComponent: () =>
                    import('./app/modules/virtual/components/entidades/entidades.component').then(
                        (m) => m.EntidadesComponent
                    )
            },
            {
                path: 'usuarios',
                loadComponent: () =>
                    import('./app/modules/virtual/components/usuarios/usuarios.component').then(
                        (m) => m.UsuariosVirtualComponent
                    )
            },
            {
                path: 'planes',
                loadComponent: () =>
                    import('./app/modules/virtual/components/planes/planes.component').then(
                        (m) => m.PlanesAdminComponent
                    )
            },
            {
                path: 'suscripciones',
                loadComponent: () =>
                    import('./app/modules/virtual/components/suscripciones/suscripciones.component').then(
                        (m) => m.SuscripcionesComponent
                    )
            }
        ]
    },
    {
        path: 'notfound',
        component: Notfound
    },
    {
        path: 'auth',
        loadChildren: () => import('./app/pages/auth/auth.routes')
    },
    {
        path: '**',
        redirectTo: '/notfound'
    }
];
